import {
  COMMAND_CONTEXTS,
  prepareEditorCommand
} from "./editorCommandRegistry.mjs";
import { closeHistory } from "@tiptap/pm/history";

export function matchSlashQuery(text, parentOffset, blockStart) {
  try {
    const source = String(text);
    if (!Number.isInteger(parentOffset)
      || parentOffset < 0
      || parentOffset > source.length
      || !Number.isInteger(blockStart)
      || blockStart < 0) return null;
    const beforeCaret = source.slice(0, parentOffset);
    const match = beforeCaret.match(/^(\s*)\/([^\s/]*)$/u);
    if (!match) return null;
    const slashOffset = match[1].length;
    return {
      from: blockStart + slashOffset,
      to: blockStart + parentOffset,
      query: match[2]
    };
  } catch {
    return null;
  }
}

export function filterSlashCommands(commands, query) {
  try {
    if (!Array.isArray(commands)) return [];
    const needle = String(query).trim().toLowerCase();
    return commands.filter((command) => !needle || [
      command.id,
      command.label,
      ...(command.aliases || [])
    ].some((value) => String(value).toLowerCase().includes(needle)));
  } catch {
    return [];
  }
}

export function executeSlashCommand(editor, commandId, range) {
  try {
    const from = range?.from;
    const to = range?.to;
    if (!Number.isInteger(from) || !Number.isInteger(to) || from < 0 || to <= from) return false;

    const selection = editor?.state?.selection;
    if (selection?.empty !== true || selection.from !== selection.to) return false;
    const resolved = selection.$from;
    const parent = resolved.parent;
    if (parent?.isTextblock !== true) return false;
    const currentRange = matchSlashQuery(parent.textContent, resolved.parentOffset, resolved.start());
    if (!currentRange || currentRange.from !== from || currentRange.to !== to) return false;

    const apply = prepareEditorCommand(editor, commandId, {}, COMMAND_CONTEXTS.SLASH);
    if (!apply) return false;
    const chain = editor.chain()
      .focus()
      .command(({ tr }) => {
        closeHistory(tr);
        return true;
      })
      .deleteRange({ from, to });
    const applied = apply(chain);
    return typeof applied?.run === "function" && applied.run() === true;
  } catch {
    return false;
  }
}
